import axios from 'axios'
import { logoutUser } from '../actions/user'

export default async (options, dispatch, type) => {
  try {
    const token = localStorage.Auth || null
    options.headers = {
      ...options.headers,
      Auth: token
    }
    options.validateStatus = status => status < 399
    dispatch({ type: `REQUEST_SENT`, options })
    dispatch({ type: `R_${type}` })
    const result = await axios(options)
    dispatch({ type: `REQUEST_SUCCESS` })
    return result
  } catch (err) {
    if (typeof err.response !== 'undefined') {
      dispatch({ type: `REQUEST_ERROR`, payload: err })
      let { status } = err.response
      switch (status) {
        case 401:
          logoutUser()(dispatch)
          break
        case 404:
          null
          break
        default:
          return err.response
      }
      return err.response
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/axios.js